<template>
  <div style="height: 100%">
    <div style="position: fixed; z-index: 999; left: 0; top: 0; width: 100px; height: 60px" @dblclick="setSettings()" title="双击打开设置"></div>
    <div class="welcome-c" v-if="switchs*1==2">
      <div class="screen" v-for="(item,index) in Urls" :key="index"><iframe scrolling="no" :src="item+'?adjust=1080'"></iframe></div>
    </div>
    <div class="welcome-c" v-else>
      <div class="index1" :style="'background: url('+img4+') no-repeat center/100%;'">
        <iframe scrolling="no" :src="website ? 'https://'+website :  dw==2?'https://www.cfbrain.cn/#/pallet':'https://www.cfbrain.cn/#/homepage'" v-if="dw!='false'"></iframe>
      </div>
      <div class="index2" :style="'background: url('+img1+') no-repeat center/100%;'"></div>
      <div class="index4" :style="'background: url('+img3+') no-repeat bottom/40%;'"></div>
      <div class="index3" :style="'background: url('+img2+') no-repeat center/100%;'"></div>
      <div class="hyy" :style="{top: top+'px'}">
        <span class="text" :title="greeting">{{greeting||'热烈欢迎'}}<em></em></span><br>
        <span class="text2" :title="speech" >{{ speech}}</span>
        <span class="text2" :title="speech2" style="margin-top: 20px">{{ speech2}}</span>
      </div>
    </div>
    <el-drawer
      title="欢迎页设置"
      :visible.sync="drawer"
      direction="rtl"
      :modal="false"
      :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="展示形式">
          <el-radio-group v-model="switchs" size="small">
            <el-radio :label="1" border>欢迎页</el-radio>
            <el-radio :label="2" border>数字工厂四宫格</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="欢迎语" v-if="switchs == 1">
          <el-input v-model="greeting"></el-input>
        </el-form-item>
        <el-form-item label="第一行" v-if="switchs == 1">
          <el-input v-model="speech"></el-input>
        </el-form-item>
        <el-form-item label="第二行" v-if="switchs == 1">
          <el-input v-model="speech2"></el-input>
        </el-form-item>
        <el-form-item label="底部网址" v-if="switchs == 1">
          <el-input v-model="website"></el-input>
          <el-checkbox v-model="dw">默认驾驶舱</el-checkbox>
        </el-form-item>
        <el-form-item label="距顶部" v-if="switchs == 1">
          <el-input v-model="top">
            <template slot="append">像素</template>
          </el-input>
        </el-form-item>
        <el-form-item label="第一屏" v-if="switchs == 2">
          <el-input v-model="Urls[0]"></el-input>
        </el-form-item>
        <el-form-item label="第二屏" v-if="switchs == 2">
          <el-input v-model="Urls[1]"></el-input>
        </el-form-item>
        <el-form-item label="第三屏" v-if="switchs == 2">
          <el-input v-model="Urls[2]"></el-input>
        </el-form-item>
        <el-form-item label="第四屏" v-if="switchs == 2">
          <el-input v-model="Urls[3]"></el-input>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "welcome",
  data () {
    return {
      drawer: false,
      form: {},
      Urls:[
        // 'https://www.cfbrain.cn/#/overview',
        'https://www.cfbrain.cn/#/homepage',
        'https://www.cfbrain.cn/#/pallet',
        // 'https://www.cfbrain.cn/#/matching',
        // 'https://www.cfbrain.cn/#/Printingdyeing',
        'https://www.cfbrain.cn/#/prosperity',
        'https://www.cfbrain.cn/#/textile',
        // 'https://www.cfbrain.cn/#/spinning',
        // 'https://www.cfbrain.cn/#/Pdworkshop'
      ],
      Urls2:[
        'https://www.cfbrain.cn/#/pallet',
        'https://www.cfbrain.cn/#/prosperity',
        'https://www.cfbrain.cn/#/textile',
        'https://www.cfbrain.cn/#/matching'
      ],
      Urls3:[
        'https://www.cfbrain.cn/#/pallet',
        'https://www.cfbrain.cn/#/prosperity',
        'https://www.cfbrain.cn/#/Pdworkshop',
        'https://www.cfbrain.cn/#/matching'
      ],
      img1:require('../assets/welcome/hierarchy2.png'),
      img2:require('../assets/welcome/embellish.png'),
      img3:require('../assets/welcome/show.gif'),
      img4:require('../assets/welcome/bg.jpg'),
      top:'210',
      speech:'中外运曹总，新凤鸣边总',
      speech2:'一行莅临指导',
      greeting:'热烈欢迎',
      dw:true,
      website:'',
      switchs:1
    }
  },
  created() {
    this.speech = this.getUrlParam('speech') || this.$route.query.speech
    this.speech2 = this.getUrlParam('speech2') || this.$route.query.speech2
    this.greeting = this.getUrlParam('greeting') || this.$route.query.greeting || '热烈欢迎'
    this.top = this.getUrlParam('top') || this.$route.query.top || '210'
    this.dw = this.getUrlParam('dw') || this.$route.query.dw || true
    this.switchs = this.getUrlParam('switch') || this.$route.query.switch || 1
    this.website = this.getUrlParam('website') || this.$route.query.website || ''
    const url = this.getUrlParam('url') || this.$route.query.url || ''
    console.log('------------',url)
    if(url!=''){
      this.Urls = this['Urls'+url]
    }
    console.log(this.dw)
    let aa=false
    console.log(aa)
  },
  methods:{
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURI(r[2])
      return null
    },
    setSettings() {
      console.log('15454')
      this.drawer = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  }
}
</script>

<style scoped>
.welcome-c{
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
}
.screen{
  float: left;
  width: calc(100% / 2);
  height: calc(100% / 2);
  flex: 1;
  background: blue;
}
.index1{
  width: 100%;
  height: 100%;
  background: red;
}

.screen iframe,.index1 iframe{
  width: 100%;
  height: 100%;
  border: 0;
}

.index2,.index3,.index4{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.index4{
  opacity: .4;
}

.hyy{
  position: absolute;
  width: 100%;
  z-index: 99;
  left: 0;
  text-align: center;
  font-family:微软雅黑;
}

.text{
  padding-right: 30px;
  font-size: 200px;
  /*font-weight: bold;*/
  position: relative;
  font-style:italic;
  letter-spacing:4px;
  width: 100%;
  background: linear-gradient(-49deg,#F4AA61,#FCEDC6,#F4AA61,#F4AA61,#FCEDC6,#EFAB60,#F4AA61,#FFD6B1 88%);
  transition: background-color 5s ease;
  -webkit-background-clip: text;
  color: transparent;
  animation: a6 .5s ease-out forwards;
  -webkit-text-stroke: 1px rgba(255,255,216,.6);
}

.text::before{
  content: attr(title);
  position: absolute;
  font-weight: normal;
  /*filter: brightness(105%);*/
  -webkit-text-stroke: 2px rgba(255,255,216,.4);
  /*z-index: -1;*/
}

.text::after{
  content: attr(title);
  position: absolute;
  font-weight: normal;
  color: #FFD6B1;
  text-shadow: 8px 12px 20px rgba(0,0,0,.6);
  width: 100%;
  left: -15px;
  z-index: -1;
}

.text em{
  width: 159px;
  height: 159px;
  background: url("../assets/welcome/light.png") no-repeat;
  position: absolute;
  top: -57px;
  left: 133px;
}

.text2{
  margin-top: 80px;
  font-size: 110px;
  display: inline-block;
  font-family:"fzskjt";
  position: relative;
  letter-spacing:4px;
  width: 100%;
  background: linear-gradient(to bottom,#F7F5E9,#F3DD7F,#C59B51,#F3ED9F,#CAA256,#F2EC9E,#FFBD83 90%);
  transition: background-color 5s ease;
  -webkit-background-clip: text;
  color: transparent;
  animation: a6 .5s ease-out forwards;
  filter: brightness(102%);
  -webkit-text-stroke: 1px rgba(246,255,238,.65);
}

.text2::after{
  /*content: attr(title);*/
  /*position: absolute;*/
  /*color: #F3DD7F;*/
  /*text-shadow: 8px 12px 20px rgba(0,0,0,.6);*/
  /*width: 100%;*/
  /*left: 0;*/
  /*top:0;*/
  /*z-index: -2;*/
}

@keyframes a6{
  0%{
    opacity:1;
    transform:scale(1.5,1.5);
  }
  100%{
    opacity:1;
    transform:scale(1,1);
  }
}

</style>



// WEBPACK FOOTER //
// src/views/welcome.vue